import React, { useEffect, useState } from "react";
import MarketoFormComponent from '../marketo/marketoFormComponent';
import '../../sass/components/flexibleModules/_components.postPerformEventIntro.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

const PostPerformEventIntro = ({ indItem, data }) => {

    useEffect(() => {
        if (data.postEventIntroFormVideo) {
            var scriptOne = document.createElement('script');
            scriptOne.src = '//fast.wistia.com/embed/medias/' + data.postEventIntroFormVideo + '.jsonp';
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }
    }, []);

    const [formShow, setFormShow] = useState(false);
    const showForm = (val) => {
        setFormShow(val);
    }

    return (
        <div className="cp-postPerformEventIntro">
            <div className="l--absolutePerformThree">
                <button onClick={() => showForm(true)} className="l-button l--flex">Watch Sessions</button>
            </div>
            <div className="l-randomgallery">
                {data.randomGallery &&
                    <>
                        {data.randomGallery.map((imageGallery, index) => (
                            <div className={`l-randomgallery__gallery l-randomgallery__gallery-${index}`} key={index}>
                                <GatsbyImage image={getImage(imageGallery.gatsbyImage)} alt={imageGallery.altText} />
                            </div>
                        ))}
                    </>
                }
            </div>
            <div className="cp-postPerformEventIntro__inner">
                {data.postEventIntroHeader &&
                    <h1 dangerouslySetInnerHTML={{ __html: data.postEventIntroHeader }} />
                }
                {data.postEventIntroContent &&
                    <p dangerouslySetInnerHTML={{ __html: data.postEventIntroContent }} />
                }
                {data.postEventIntroTeaser &&
                    <p dangerouslySetInnerHTML={{ __html: data.postEventIntroTeaser }} />
                }
                <button onClick={() => showForm(true)} className="l-button l--flex">Watch Sessions</button>
                <div className="cp-postPerformEventIntro__formVideo l--flex">
                    {formShow &&
                        <div className="cp-postPerformEventIntro__formVideo-left" id="l-leftForm">
                            {data.postEventIntroFormNumber &&
                                <MarketoFormComponent indItem={indItem} ctaOverride={data.postEventIntroFormCta} formSubmitMessage={data.postEventIntroFormThankYou} formId={data.postEventIntroFormNumber} />
                            }
                            <button onClick={() => showForm(false)} className="l-backgroundTrigger"></button>
                        </div>
                    }
                    <div className="cp-postPerformEventIntro__formVideo-right">
                        {data.postEventIntroFormVideo &&
                            <div className="l-embedWrap">
                                <div className="l-embedWrap__inner">
                                    <div className={`wistia_embed wistia_async_${data.postEventIntroFormVideo}`}>&nbsp;</div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PostPerformEventIntro;